import FileUploadComponent from "./FileUploadComponent";

export default FileUploadComponent;